import adpater from './adapter'

export default {
  collection: adpater.getInitialState(),
}
